const getters = {
  moduleName: state => {
    return state.module ? state.module.name : "";
  },
  moduleTitle: state => {
    return state.module ? state.module.title : "";
  },
  moduleIcon: state => {
    return state.module ? state.module.icon : "";
  },
  moduleEntity: state => {
    return state.module ? state.module.entity : "";
  },
  permittedModules: state => state.permittedModules,
  userManagement: state => {
    return state.userManagement;
  },
  roleGroup: state => {
    return state.roleGroup;
  },
  roleGroupAssociation: state => {
    return state.roleGroupAssociation;
  },
  roles: state => {
    return state.roles;
  },
  applicationList: state => {
    return state.applicationList;
  },
  applicationContractList: state => {
    return state.applicationContractList;
  },
  userAssociatedRoleGroups: state => {
    return state.userAssociatedRoleGroups;
  },
  searchedRoleGroups: state => {
    return state.searchedRoleGroups;
  },
  associatedRoles: state => {
    return state.associatedRoles;
  },
  associationTypes: state => {
    return state.associationTypes;
  },
  employeeAssociations: state => {
    return state.employeeAssociations;
  },
  searchedUserList: state => {
    return state.searchedUserList;
  },
  processTypes: state => {
    return state.processTypes;
  },
  workflows: state => {
    return state.workflows;
  },
  actions: state => {
    return state.actions;
  },
  processAssociations: state => {
    return state.processAssociations;
  },
  userGroups: state => {
    return state.userGroups;
  },
  usersInUserGroup: state => {
    return state.usersInUserGroup;
  },
  availableStatus: state => {
    return state.availableStatus;
  },
  statusConfiguration: state => {
    return state.statusConfiguration;
  },
  userGroupAssociation: state => {
    return state.userGroupAssociation;
  },
  approvalGroups: state => {
    return state.approvalGroups;
  },
  usersInApprovalGroup: state => {
    return state.usersInApprovalGroup;
  },
  associatedUserGroupsWithApprovalGroup: state => {
    return state.associatedUserGroupsWithApprovalGroup;
  },
  availableNextStatus: state => {
    return state.availableNextStatus;
  }
};

export default getters;
